import React, { PropsWithChildren } from 'react'
import { Typography } from 'antd'
import { TextProps } from 'antd/lib/typography/Text'

export const Text: React.FC<PropsWithChildren<TextProps>> = ({
  children,
  ...rest
}) => {
  return (
    <Typography.Text style={{ fontSize: '1rem' }} {...rest}>
      {children}
    </Typography.Text>
  )
}
